<script setup>
import { useChat } from "@/composables/useSidebar";

useHead({
  title: "UpBit",
});

const { isNotificationOpen, closeNotification } = useChat();
</script>

<template>
  <LayoutHeader />
  <slot />
  <CommonChatSection />
  <CommonNotification
    :is-open="isNotificationOpen"
    @close="closeNotification"
  />
</template>

<style scoped></style>
